export type ParameterKey =
    | 'projectGroup'
    | 'owner'
    | 'buildingType'
    | 'constructionType'
    | 'contractType'
    | 'sustainability'
    | 'geographicRegion'
    | 'seismicZone'
    | 'windZone'

export type ParameterToggleState = Record<ParameterKey, boolean>
export type ParameterSelectedState = Record<ParameterKey, string[]>
export type ParameterOptionsMap = Record<ParameterKey, string[]>

export const parameterConfig: { key: ParameterKey; label: string }[] = [
    { key: 'projectGroup', label: 'Project Group' },
    { key: 'owner', label: 'Owner' },
    { key: 'buildingType', label: 'Building Type' },
    { key: 'constructionType', label: 'Construction Type' },
    { key: 'contractType', label: 'Contract Type' },
    { key: 'sustainability', label: 'Sustainability' },
    { key: 'geographicRegion', label: 'Geographic Region' },
    { key: 'seismicZone', label: 'Seismic Zone' },
    { key: 'windZone', label: 'Wind Zone' },
]

export const emptyParameterToggles: ParameterToggleState = {
    projectGroup: false,
    owner: false,
    buildingType: false,
    constructionType: false,
    contractType: false,
    sustainability: false,
    geographicRegion: false,
    seismicZone: false,
    windZone: false,
}

export const emptyParameterSelected: ParameterSelectedState = {
    projectGroup: [],
    owner: [],
    buildingType: [],
    constructionType: [],
    contractType: [],
    sustainability: [],
    geographicRegion: [],
    seismicZone: [],
    windZone: [],
}

export type BPMode = 'none' | 'parameter' | 'global'

export interface BPStagedConfig {
    mode: BPMode
    projectGroup?: string
    parameterSelected: ParameterSelectedState
}

export const initialBPStagedConfig: BPStagedConfig = {
    mode: 'none',
    projectGroup: undefined,
    parameterSelected: emptyParameterSelected,
}
